
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavyRainShowersDay as ObiHeavyRainShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-rain-showers-day.js';
 
 
 

 
 export const ObiHeavyRainShowersDay = createComponent({
   react: React,
   tagName: 'obi-heavy-rain-showers-day',
   elementClass: ObiHeavyRainShowersDayElement,
   events: {
     
   }
  });
 
 